__turbopack_context__.v({
  "ImageVideo": "v_g0IG_ImageVideo",
  "ImageVideo--Full": "v_g0IG_ImageVideo--Full",
  "ImageVideo--Large": "v_g0IG_ImageVideo--Large",
  "ImageVideo--Medium": "v_g0IG_ImageVideo--Medium",
  "ImageVideo--Small": "v_g0IG_ImageVideo--Small",
  "ImageVideo--Xsmall": "v_g0IG_ImageVideo--Xsmall",
  "ImageVideo__Caption": "v_g0IG_ImageVideo__Caption",
  "ImageVideo__Image": "v_g0IG_ImageVideo__Image",
});
